const {bind} = require('./lib/bind')
const DragDrop = require('./upload/dragdrop')
const Upload = require('./upload/upload')
const Poll = require('./upload/poll')

bind(document, "DOMContentLoaded", function() {
  const element = document.querySelector('.js-upload-form')
  const reprocess = document.querySelector('.js-upload-reprocess')

  if (element) {
    const dragdrop = new DragDrop(element)

    switch (element.dataset.status) {
      case 'pending':
      case 'processing':
        dragdrop.hideElement()
        break
      case 'processed':
      case 'failed':
        dragdrop.removeEvents()
        break
    }

    bind(reprocess, 'click', function() {
      document.querySelector('.js-upload-processed').classList.add('d-none')
      document.querySelector('.js-upload-form').classList.remove('d-none')
      dragdrop.showElement()
    })

    const file = document.querySelector('.js-upload-field')

    if (file) {
      bind(file, 'change', function() {
        const upload = new Upload(dragdrop)
        console.log('upload', upload)
        upload.start()
      })
    }
  }

  const polls = document.querySelectorAll('[data-poll-url]')

  Array.from(polls).forEach(function(element) {
    new Poll(element.dataset.pollUrl)
  })
})
